<script>
import DebtFilter from "./DebtFilter.vue";
import useSharedData from "@/use/SharedData.js";
import {useDebtStore} from "@/stores/Debt.js";
import useTools from "@/use/Tools.js";
import useSharedMethod from "@/use/SharedMethod.js";
import {watch, ref, computed} from "vue";
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";
import {storeToRefs} from "pinia";

export default {
    props: {
        pay_day_advance: Boolean,
    },
    components: {DebtFilter},
    setup(props) {
        const {loading, total, itemsPerPage, filter,} = useSharedData();
        const debtStore = useDebtStore();
        const securityStore = useSecurityStore();
        const {$i18n, $router} = useTools();
        const {transformFilterValues, formatedDate, priceFormat, getRestState, formatedMonth} = useSharedMethod();

        const rootPath = computed(() => props.pay_day_advance ? 'pay_day_advances' : 'debts');

        const headers = ref([
            {
                text: "",
                align: "start",
                sortable: false,
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "code",
                width: "0%",
            },
            {
                text: $i18n.t("module.worker"),
                align: "start",
                sortable: true,
                value: "workerLastName",
                width: "0%",
            },
            {
                text: $i18n.t("common.date"),
                align: "start",
                sortable: true,
                value: "date",
                width: "0%",
            },
            {
                text: $i18n.t("debts.start_at"),
                align: "start",
                sortable: true,
                value: "startAt",
                width: "0%",
            },
            {
                text: $i18n.t("common.amount"),
                align: "start",
                sortable: true,
                value: "price",
                width: "0%",
            },
            {
                text: $i18n.t("common.duration"),
                align: "start",
                sortable: true,
                value: "duration",
                width: "0%",
            },
            {
                text: $i18n.t("common.refunded"),
                align: "start",
                sortable: false,
                value: "refunded",
                width: "0%",
            },
            {
                text: $i18n.t("common.rest"),
                align: "start",
                sortable: true,
                value: "rest",
                width: "0%",
            },
            {
                text: $i18n.t("common.description"),
                align: "start",
                sortable: true,
                value: "observation",
            },
            {
                text: $i18n.t("debts.refund_status"),
                align: "start",
                sortable: false,
                value: "restState",
                width: "0%",
            },
            {
                text: $i18n.t("common.validation"),
                align: "start",
                sortable: true,
                value: "validationStatus.lastState",
                width: "0%"
            },
            {
                text: $i18n.t("common.validation_date"),
                align: "start",
                sortable: true,
                value: "validationStatus.lastValidationDate",
                width: "0%"
            },
            {
                text: $i18n.t("common.next_validator"),
                align: "start",
                sortable: true,
                value: "validationStatus.nextValidator",
                width: "0%"
            },
            {
                text: $i18n.t('common.set_decision'),
                align: "start",
                sortable: true,
                value: "setDecision",
                width: "0%"
            },
        ]);

        const actions = [
            {
                title: $i18n.t("debts.add_cash"),
                icon: 'mdi-plus-circle-outline',
                color: 'blue darken-2',
                access: (item) => item.updateOption && item.rest > 0 && item.validationStatus.status === 'ACCEPT',
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.refunds.add`, params: { id: item.id }})
                },
            },
            {
                title: $i18n.t('debts.report'),
                icon: 'mdi-pinwheel',
                color: 'blue darken-2',
                access: (item) => item.updateOption && item.rest > 0 && item.validationStatus.status === 'ACCEPT',
                disabled: () => false,
                func: (item) => {
                    $router.push({ name: `${rootPath.value}.report`, params: { id: item.id }})
                },
            },
            {
                title: $i18n.t('debts.refund_history'),
                icon: 'mdi-playlist-check',
                color: 'blue darken-2',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.refunds`, params: { id: item.id }})
                },
            },
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: (item) => item.updateOption && item.rest === item.price,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.edit`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: (item) => item.deleteOption && item.rest === item.price,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.delete`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("module.edms"),
                icon: 'mdi-folder',
                color: 'amber',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.documents`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("module.template_application"),
                icon: 'mdi-text-box-multiple',
                color: 'teal',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.template_applications`, params: {id: item.id}})
                },
            },
        ];

        const {itemsToBeValidate} = storeToRefs(securityStore);

        const searchParams = ref({
            sortBy: "date",
            descending: true,
            page: 1,
            itemsPerPage: itemsPerPage
        });

        function handleSearch(params) {
            loading.value = true;
            debtStore.setDebts([]);
            total.value = 0;

            filter.value.type = props.pay_day_advance ? "PAY_DAY_ADVANCE" : "NORMAL";
            filter.value.itemsToBeValidate = itemsToBeValidate.value;

            loading.value = true;
            filter.value.page = params.page - 1;
            filter.value.rowsPerPage = params.itemsPerPage;
            filter.value.sortBy = params.sortBy;
            filter.value.descending = params.descending;

            axios.get('/debts', {params: transformFilterValues(filter.value)}).then((response) => {
                debtStore.setDebts(response.data.elements);
                total.value = response.data.total;
            }).finally(() => {
                loading.value = false;
            });
        }

        function findAll() {
            handleSearch(searchParams.value)
        }

        watch(() => [filter.value, itemsToBeValidate.value], () => {
            searchParams.page = 1;
            findAll();
        }, {deep: true, immediate: true});

        watch(searchParams, (newParams) => {
            handleSearch(newParams);
        }, {deep: true});

        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                filter.value[key] = null;
            });
            itemsToBeValidate.value = false;
        }

        function view(item) {
            $router.push({name: `${rootPath.value}.view`, params: {id: item.id}});
        }


        return {
            rootPath,
            securityStore,
            debtStore,
            loading,
            total,
            itemsPerPage,
            filter,
            headers,
            actions,
            searchParams,
            itemsToBeValidate,
            clearFilter,
            findAll,
            view,
            getRestState,
            formatedDate,
            priceFormat,
            formatedMonth
        }
    },
};
</script>

<template>
    <div>
        <w-app
            :title="pay_day_advance ? $t('module.pay_day_advance') : $t('module.debt')"
            show-total
            :total="total"
            show-filter
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
                <DebtFilter v-model="filter" :pay_day_advance="pay_day_advance"/>
            </template>

            <template v-slot:leftToolbar>
                <v-checkbox
                    v-model="itemsToBeValidate"
                    :label="$t('common.requests_need_validation')"
                    :true-value="true"
                    :false-value="false"
                    class="ml-2"
                    hide-details
                />
            </template>

            <template v-slot:rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
                <w-btn-add
                    :show="securityStore.authorities['SAVE_DEBT']"
                    @press="$router.push({name: `${rootPath}.add`})"
                />
            </template>

            <template v-slot:content>
                <w-server-data-table
                    v-model="searchParams"
                    :actions="actions"
                    :headers="headers"
                    :items="debtStore.debts"
                    :loading="loading"
                    :total="total"
                    show-validation
                    :root-path="rootPath"
                    module="DEBT"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:[`item.workerLastName`]="{ item }">
                        <w-inline-text bold :text="item.workerName"/>
                    </template>
                    <template v-slot:[`item.date`]="{ item }">
                        <w-inline-text :text="formatedDate(item.date)"/>
                    </template>
                    <template v-slot:[`item.startAt`]="{ item }">
                        <w-inline-text :text="formatedMonth(item.startAt)"/>
                    </template>
                    <template v-slot:[`item.duration`]="{ item }">
                        <w-inline-text :text="item.duration"/>
                    </template>
                    <template v-slot:[`item.price`]="{ item }">
                        <w-inline-text :text="priceFormat(item.price)"/>
                    </template>
                    <template v-slot:[`item.refunded`]="{ item }">
                        <w-inline-text :text="priceFormat(item.refunded)"/>
                    </template>
                    <template v-slot:[`item.rest`]="{ item }">
                        <w-inline-text :text="priceFormat(item.rest)"/>
                    </template>
                    <template v-slot:[`item.restState`]="{ item }">
                        <w-chip :color="getRestState(item).color" :text="$t(`debts.${getRestState(item).state}`)"/>
                    </template>
                </w-server-data-table>
            </template>
        </w-app>
        <router-view/>
    </div>
</template>